import styled from 'styled-components';
import { BouncingLetter } from '../letterEffect/BouncingLetter';

export const Contact = () => {
    return (
        <Container>
            <TitleContainer>
                <Title>
                    <BouncingLetter letter={'C'} index={0} />
                    <BouncingLetter letter={'O'} index={1} />
                    <BouncingLetter letter={'N'} index={2} />
                    <BouncingLetter letter={'T'} index={3} />
                    <BouncingLetter letter={'A'} index={4} />
                    <BouncingLetter letter={'C'} index={5} />
                    <BouncingLetter letter={'T'} index={6} />
                    <div style={{ width: 20 }} />
                    <BouncingLetter letter={'U'} index={6} />
                    <BouncingLetter letter={'S'} index={6} />
                </Title>
            </TitleContainer>
            <PrinciplesContainer />
        </Container>
    );
};

const Container = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
`;

const TitleContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: 1;
`;

const Title = styled.div`
    display: flex;
    flex-direction: row;
`;

const PrinciplesContainer = styled.div`
    width: 100%;
    flex: 1;
`;
